
export const urlHelpCenter = '/help-center'
export const urlPage = '/page'